import React from 'react';
import { Box, Typography, Button, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EnhancedSkeleton from '../Summary/EnhancedSkeleton';
import { recommendedStyles } from '../../styles/qaStyles';

/**
 * 추천 질문들 컴포넌트
 * @param {object} props - 컴포넌트 props
 * @param {Array} props.recommendedQuestions - 추천 질문 배열
 * @param {function} props.handleRecommendedQuestionClick - 추천 질문 클릭 핸들러
 * @param {boolean} props.isSummaryReady - 요약 준비 여부
 * @param {boolean} props.isChaptersReady - 챕터 준비 여부
 * @returns {JSX.Element} - 추천 질문들
 */
const RecommendedQuestions = ({ 
  recommendedQuestions, 
  handleRecommendedQuestionClick, 
  isSummaryReady, 
  isChaptersReady 
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={recommendedStyles.container}>
      <Typography variant="subtitle2" sx={recommendedStyles.title}>
        {t('analyze.recommendedQuestions')}
      </Typography>
      <Box sx={{
        ...recommendedStyles.questionsContainer,
        flexDirection: (isSummaryReady && isChaptersReady && recommendedQuestions.length > 0) ? 'row' : 'column'
      }}>
        {Array.from(new Array(3)).map((_, idx) => {
          const isQuestionReady = isSummaryReady && isChaptersReady && recommendedQuestions[idx];
          
          return (
            <Box
              key={idx}
              onClick={() => {
                if (isQuestionReady) {
                  handleRecommendedQuestionClick(recommendedQuestions[idx]);
                }
              }}
              sx={{
                ...recommendedStyles.questionItem,
                ...(isQuestionReady ? {} : recommendedStyles.questionItemDisabled)
              }}
            >
              {isQuestionReady ? (
                recommendedQuestions[idx]
              ) : (
                <Box>
                  <EnhancedSkeleton variant="text" height={14} width="75%" animationType="shimmer" sx={{ mb: 0.5 }} />
                  <EnhancedSkeleton variant="text" height={14} width="60%" animationType="gradient-flow" />
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default RecommendedQuestions; 